<template>
  <van-overlay :show="show" :z-index="9999" @click="show = false">
    <div class="wrapper">
      <div class="login-container" @click.stop="() => {}">
        <!-- <div class="login-bg">
        <img :src="bgImg" alt="" />
      </div> -->

        <van-form ref="form" class="tab-form" @submit="onSubmit">
          <div class="tabs-card" v-if="gameInfos">
            <van-tabs v-model="tabActive" @change="handleTabChange">
              <van-tab
                v-if="gameInfos && gameInfos.msg_type === 1"
                :title="$t('login.phoneLogin')"
                name="phone"
              >
                <div v-if="tabActive === 'phone'">
                  <van-field
                    v-model="phone"
                    :name="$t('login.phone')"
                    :label="$t('login.phone')"
                    :placeholder="$t('login.phone')"
                    :rules="[
                      { required: true, message: $t('login.phoneRequired') },
                      {
                        pattern: /^1[3-9]\d{9}$/,
                        message: $t('login.rightPhone'),
                      },
                    ]"
                  />
                  <van-field
                    v-model="captchaCode"
                    :maxlength="6"
                    type="code"
                    label-class="label-class"
                    :name="$t('login.picCode')"
                    :label="$t('login.picCode')"
                    :placeholder="$t('login.picCode')"
                    :rules="[
                      { required: true, message: $t('login.picCodeRequired') },
                    ]"
                  >
                    <template #button>
                      <van-image
                        width="85"
                        fit="contain"
                        :src="captchaUrl"
                        @click="getCaptchaCode"
                      />
                    </template>
                  </van-field>
                  <van-field
                    v-model="code"
                    :maxlength="6"
                    type="code"
                    :name="$t('login.code')"
                    :label="$t('login.code')"
                    :placeholder="$t('login.code')"
                    :rules="[
                      { required: true, message: $t('login.codeRequired') },
                    ]"
                  >
                    <template #button>
                      <van-button
                        native-type="button"
                        @click="getSms"
                        type="primary"
                        size="mini"
                        >{{
                          showTimer
                            ? `${$t("login.reSend")}(${second}s)`
                            : $t("login.sendCode")
                        }}
                      </van-button>
                    </template>
                  </van-field>
                </div>
              </van-tab>
              <van-tab
                v-if="gameInfos && gameInfos.msg_type === 2"
                :title="$t('login.emailLogin')"
                name="email"
              >
                <div v-if="tabActive === 'email'">
                  <van-field
                    v-model="email"
                    :name="$t('login.email')"
                    :label="$t('login.email')"
                    :placeholder="$t('login.email')"
                    :rules="[
                      { required: true, message: $t('login.emailRequired') },
                      {
                        pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
                        message: $t('login.rightEmail'),
                      },
                    ]"
                  />
                  <van-field
                    v-model="code"
                    type="code"
                    :name="$t('login.code')"
                    :label="$t('login.code')"
                    :placeholder="$t('login.code')"
                    :rules="[
                      { required: true, message: $t('login.codeRequired') },
                    ]"
                  >
                    <template #button>
                      <van-button
                        native-type="button"
                        @click="getSms"
                        type="primary"
                        size="mini"
                        >{{
                          showTimer
                            ? `${$t("login.reSend")}(${second}s)`
                            : $t("login.sendCode")
                        }}
                      </van-button>
                    </template>
                  </van-field>
                </div>
              </van-tab>
            </van-tabs>
            <div class="marginB10 marginL10 marginT10 marginR10">
              <van-button
                class="login-btn"
                block
                type="primary"
                size="large"
                native-type="submit"
              >
                {{ $t("login.login") }}
              </van-button>
            </div>
          </div>
          <van-empty v-else :description="$t('login.请选择游戏')" />
        </van-form>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import {
  apiGetLoginCode,
  apiLogin,
  apiGameLogin,
  apiGetCaptchaCode,
  apiMoyuSdkLogin,
} from "@/api/user";
import storage from "@/utils/storage";
import { loginBg } from "./mixins";
import { mapActions } from "vuex";
import { getQuery } from "@/utils/util";

export default {
  mixins: [loginBg],
  data() {
    return {
      show: false,
      phone: "",
      email: "",
      code: "",
      showTimer: false,
      second: 0,
      timer: null,
      tabActive: "phone",
      captchaCode: "",
      captchaUrl: "",
    };
  },
  beforeDestroy() {
    this.clearTimer();
    this.$eventBus.$off("showLogin");
  },
  created() {
    let { game_id } = this.$route.query;
    console.log(location.href);
    if (game_id) {
      sessionStorage.setItem("game_id", Number(game_id));
    } else {
      // 解决app内无法通过$route.query;获取参数
      const query = getQuery(location.href);
      game_id = query.game_id;
      if (game_id) {
        sessionStorage.setItem("game_id", Number(game_id));
      }
    }
  },
  mounted() {
    const game_id = sessionStorage.getItem("game_id");
    const token = storage.getItem("token");
    console.log(game_id, process.env.NODE_ENV);
    // 摸鱼社登录
    if (
      !token &&
      game_id &&
      navigator &&
      navigator.userAgent &&
      navigator.userAgent.includes("Hero")
    ) {
      moyuJSSDK.init({
        dev: process.env.NODE_ENV == "preview", // dev为真，测试环境
        gameId: game_id, // 游戏id，创魔 126  王牌157  灵魂228  星际 2174，不传则默认2174
        success: (res) => {
          console.log(res.token, res.statusBarHeight, res.colorMode);
          apiMoyuSdkLogin({
            token: res.token,
            game_id: game_id,
          }).then((res) => {
            if (res.code === 0) {
              storage.removeItem("token");
              storage.setItem("token", res.data.token);
              // 检查是否有角色
              this.checkUserRole();
            }
          });
        },
        fail: (err) => {
          console.log(err);
        },
      });
    }
    // 监听打开登录弹窗
    this.$eventBus.$on("showLogin", () => {
      this.show = true;
      this.getLoginBg().then(() => {
        this.tabActive =
          this.gameInfos && this.gameInfos.msg_type === 2 ? "email" : "phone";
      });
      // 判断是否为自动绑定角色用户
      // this.autoBindRole();
      this.getCaptchaCode();
    });
  },
  methods: {
    ...mapActions(["getKfInit", "getRoleList", "getIndexData"]),
    // 获取图形验证码
    getCaptchaCode() {
      apiGetCaptchaCode().then((res) => {
        if (res.code === 0) {
          this.captchaUrl = res.data.picPath || "";
        }
      });
    },
    // 自动绑定逻辑
    autoBindRole() {
      const { data, game_id } = this.$route.query;
      if (data) {
        const params = {
          data,
        };
        if (game_id) {
          params.game_id = game_id;
        }
        this.showLoading();
        apiGameLogin(params)
          .then((res) => {
            if (res.code === 0) {
              storage.removeItem("token");
              storage.setItem("token", res.data.token);
              // sessionStorage.setItem('game_id', Number(res.data.game_id));
              // 检查是否有角色
              this.checkUserRole();
            }
          })
          .finally(() => {
            this.hideLoading();
          });
      }
    },
    // 判断是否有角色
    checkUserRole() {
      // 判断是否有角色
      this.getRoleList()
        .then((res) => {
          if (res.code === 0) {
            if (!res.data.length) {
              path = "";
              this.$router.replace({
                path: "/bind-roles",
              });
            }
          }
        })
        .finally(() => {
          this.$eventBus.$emit("loginSuccess");
        });
    },
    handleTabChange() {
      this.code = "";
    },
    getSms() {
      if (!this.captchaCode) {
        this.$toast(this.$t("login.picCodeRequired"));
        return;
      }
      if (!this.phone && this.tabActive === "phone") {
        this.$toast(this.$t("login.phoneRequired"));
        return;
      } else if (!this.email && this.tabActive === "email") {
        this.$toast(this.$t("login.emailRequired"));
        return;
      }
      let params = {
        phone: this.phone,
        code: this.captchaCode,
        type: "login",
      };
      if (this.tabActive === "email") {
        params.email = this.email;
        delete params.phone;
      }
      if (!this.showTimer) {
        apiGetLoginCode(params).then((res) => {
          if (res.code === 0) {
            this.showTimer = true;
            this.second = 60;
            this.timer = setInterval(() => {
              this.second = this.second - 1;
              if (this.second == 0) {
                this.clearTimer();
                return;
              }
            }, 1000);
          } else {
            this.getCaptchaCode();
          }
        });
      }
    },
    onSubmit() {
      let params = {
        code: Number(this.code),
      };
      if (sessionStorage.getItem("open_id")) {
        params.openid = sessionStorage.getItem("open_id");
      }
      if (this.tabActive === "phone") {
        params.phone = this.phone;
      } else {
        params.email = this.email;
      }
      apiLogin(params).then((res) => {
        if (res.code === 0) {
          storage.removeItem("token");
          storage.setItem("token", res.data.token);
          this.show = false;
          // 判断是否有角色
          this.getRoleList()
            .then((res) => {
              if (res.code === 0) {
                if (!res.data.length) {
                  path = "";
                  this.$router.replace({
                    path: "/bind-roles",
                  });
                }
              }
            })
            .finally(() => {
              this.$eventBus.$emit("loginSuccess");
            });
        }
      });
    },
    // 清除定时器
    clearTimer() {
      this.showTimer = false;
      this.second = 0;
      clearInterval(this.timer);
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.login-container {
  .tab-form {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    .tabs-card {
      width: 100%;
      margin-top: 18px;
      overflow: hidden;
      background: #fff;
    }
  }
  .login-btn {
    height: 40px;
  }
  .login-bg {
    font-size: 0;
    img {
      width: 100%;
    }
  }
}
</style>
